import React, { Component } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { hydrate } from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import 'babel-polyfill';

import App from '@components/app';
import configureStore, { State } from 'client/store';
import { SizesProvider } from 'react-sizes';

import { BundleProps, BundleData } from './index';

export class DesktopBundle extends Component<BundleProps> {
    public shouldComponentUpdate() {
        return true;
    }

    public render() {
        const { data } = this.props;

        return (
            <App data={data} />
        );
    }
}

export default (data: BundleData, initialState: State) => {
    const { store, history } = configureStore(initialState);
    const state = store.getState();

    hydrate(
        <ReduxProvider store={store}>
            <ConnectedRouter history={history}>
                <SizesProvider config={data.sizesFallback}>
                    <DesktopBundle data={data} state={state} />
                </SizesProvider>
            </ConnectedRouter>
        </ReduxProvider>,
        document.getElementById('mount')
    );
};
